import type { ComponentType } from 'react';

import type { TokenPeriod } from '@ui/uikit/components/common/Chart';
import { PeriodConfig } from '@ui/uikit/components/common/Chart';
import type { ChangeType} from '@ui/uikit/components/common/Numeral';
import { Numeral } from '@ui/uikit/components/common/Numeral';
import { ArrowLongRight } from '@ui/uikit/components/icons/mono/ArrowLongRight';
import { TrendDown } from '@ui/uikit/components/icons/mono/TrendDown';
import { TrendUp } from '@ui/uikit/components/icons/mono/TrendUp';

import styles from './TokenPriceChange.module.scss';

type TokenPriceChangeProps = {
  percentChange: number | null;
  currentPrice?: number;
  period: TokenPeriod;
};

const ChangeTypeToIconMap: Record<ChangeType, ComponentType<{ className?: string }>> = {
  positive: TrendUp,
  negative: TrendDown,
  neutral: ArrowLongRight,
};

export const TokenPriceChange = ({
  percentChange,
  currentPrice = 0,
  period,
}: TokenPriceChangeProps) => {
  return (
    <Numeral
      format="percents"
      highlightChanges
      showSign
      value={Number(percentChange ?? 0)}
      renderFunction={({ renderValue, changeType }) => {
        const Icon = ChangeTypeToIconMap[changeType];

        return (
          <div className={styles.wrapper}>
            <div>${currentPrice}</div>
            {!!renderValue && (
              <div className={styles.valueWithIcon}>
                {renderValue} <Icon className={styles.icon} />
              </div>
            )}
            <div>{PeriodConfig[period].label}</div>
          </div>
        );
      }}
    />
  );
};
